import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import IconShow from '@material-ui/icons/Visibility';
import IconHide from '@material-ui/icons/VisibilityOff';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = theme => ({
	icon: {
		marginLeft: 10,
		fontSize: 16,
		verticalAlign: 'top',
		cursor: 'pointer'
	},
	masked: {
		color: theme.palette.text.disabled
	},
	wrapText: {
		wordBreak: 'break-all'
	}
});

const SecureField = withStyles(styles)(({ classes, source, securePropertyName, record = {} }) => {
	const [visible, setVisible] = useState(false);
	const isSecure = get(record, securePropertyName);
	if (isSecure) {
		const value = get(record, source);
		if (visible) {
			return <span className={classes.wrapText}>{value} <IconHide className={classes.icon} onClick={() => setVisible(false)} /></span>
		} else {
			const masked = 'X'.repeat(value ? value.length : 0);
			return <span className={classNames(classes.wrapText, classes.masked)}>{masked} <IconShow className={classes.icon} onClick={() => setVisible(true)} /></span>;
		}
	} else {
		return <span className={classes.wrapText}>{get(record, source)}</span>;
	}
});

SecureField.propTypes = {
	label: PropTypes.string,
	record: PropTypes.object,
	source: PropTypes.string.isRequired,
	securePropertyName: PropTypes.string.isRequired
};

SecureField.defaultProps = {
	addLabel: true
};

export default SecureField;
